import React from 'react';
import PropTypes from 'prop-types';

const ImageOverlayTeaser = ({ title, subtitle, image, ctaText, ctaLink }) => {
  let imageStyle = {};
  if (image) {
    imageStyle = { backgroundImage: `url(${image})` };
  }
  return (
    <div className="image-overlay-teaser border-radius-l background-size-cover background-position-center h-100 fade-overlay-new d-flex align-items-center flex-grow-1" style={ imageStyle }>
      <div className="image-overlay-teaser__inner p-a-6 fade-overlay__inner text-center flex-grow-1">
        <h3 className="image-overlay-teaser__title m-b-0 like-h3">{title}</h3>

        {subtitle &&
        <p className="image-overlay-teaser_summary m-t-2 m-b-0 like-h5">{subtitle}</p>
        }
  
        {ctaText && ctaLink &&
        <a href={ctaLink} className="btn btn--l m-t-4">{ctaText}</a>
        }
      </div>
    </div>
  );
};

ImageOverlayTeaser.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
};

export default ImageOverlayTeaser;



// WEBPACK FOOTER //
// ./library/app/components/Global/Teasers/ImageOverlayTeaser.js